/***
 * Created on 2023/7/24
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import myqnapcloud_img from "../../../static/img/service/myqnapcloud.svg";
import ic_sys_svg from "../../../static/img/utils/ic-sys-info.svg";
import RemoveUserAppDialog from "./remove_user_app_dialog";
import {formatDate, formatTime} from "../../../service/datetime";
import {useTranslation} from "react-i18next";
import BetaProgramDialog from "./beta_program_dialog";

const SCOPE_DESCRIPTION = {
    "scope.user": "@scope.user@",
    "scope.user.write": "@scope.user.write@",
    "scope.device": "@scope.device@",
    "scope.device.write": "@scope.device.write@",
    "scope.favorite": "@scope.favorite@",
    "scope.favorite.write": "@scope.favorite.write@",
    "scope.file": "@scope.file@",
    "scope.file.write": "@scope.file.write@",
    "scope.share": "@scope.share@",
    "scope.share.write": "@scope.share.write@",
    "scope.cloudlink": "@scope.cloudlink@",
    "scope.ddns": "@scope.ddns@",
    "scopeset_access_device": "@scopeset_access_device@",
    "scopeset_device_auth": "@scopeset_device_auth@",
    "scopeset_qmiix_partner": "@scopeset_qmiix_partner@",
    "scopeset_qmiix": "@scopeset_qmiix@",
    "oscar_admin.order": "test1",
    "oscar_admin.pregen": "test2",
    "oscar_admin.pregen.write": "test3"
}

function ApplicationRecord({data}) {
    const [showRemoveApp, setShowRemoveApp] = useState(false);
    const [active, setActive] = useState('');
    const [showBetaDialog, setShowBetaDialog] = useState(false);
    const { t } = useTranslation();

    const toggleActive = () => {
        setActive(prev => prev === '' ? 'active' : '');
    }

    const normalizedScopeSet = () => {
        if (!data.scopeset) return [];
        return [].concat(...Object.values(data.scopeset)).filter(scope => Object.keys(SCOPE_DESCRIPTION).includes(scope));
    }

    return (
        <>
            <div className="application__row">
                <div className="application__row__row-top">
                    <div className="comp-group-info">
                        <div className="group-info--img">
                            { !data?.img_url && <img src={myqnapcloud_img} /> }
                            { data?.img_url && <img src={data.img_url} onError={e => e.target.src=myqnapcloud_img}/> }
                        </div>
                        <div className="group-info--detail">
                            <div className="group-info--detail__main-text text-ellipsis">{data.display_name}</div>
                            <div className="group-info--detail__sub-text">{t('@Approved at@')} {formatDate(t, data.last_login_at, true, '/')} {formatTime(data.last_login_at)}</div>
                        </div>
                    </div>
                    <div className={!data?.trust && data.beta_program ? 'q-btn-group' : ''}>
                        {
                            data?.beta_program &&
                            <button className="q-btn q-btn--default btn-rounded-full min-w-0 !pl-18 !pr-18" onClick={()=>setShowBetaDialog(true)}>
                                {data?.join_beta_program ? t('@Leave beta@') : t('@Join beta@')}
                            </button>
                        }
                        {
                            !data?.trusted && <button className="q-btn q-btn--default btn-rounded-full min-w-0 !pl-18 !pr-18 !color-red" onClick={()=>setShowRemoveApp(true)}>{t('@Remove@')}</button>
                        }
                    </div>
                </div>
                <div className="application__row__row-bottom">
                    <div className="application__row__row-bottom__content">
                        <div className="application__row__row-bottom__desc">
                            {
                                data.join_beta_program &&
                                <div className="display-flex color-blue font-medium mb-8">
                                    <img src={ic_sys_svg} className="w-18px h-18px mr-5 mt-1" alt=""/>
                                    {t('@You have joined as beta tester for this app.@')}
                                </div>

                                }
                            {data.description}
                        </div>

                        { !data?.trusted &&
                            <div className={`application__row__row-bottom__accessible-content ${active}`} onClick={toggleActive}>
                                <div className="application__row__row-bottom__accessible-items">
                                    <ul>
                                        <li li-head={""}>{t('@This app can@')}</li>
                                        {
                                            normalizedScopeSet().map(scope => <li key={scope}>{t(SCOPE_DESCRIPTION[scope])}</li>)
                                        }
                                    </ul>
                                </div>
                                <div className="expand-trigger-arrow cursor-pointer"></div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            {
                showRemoveApp &&
                <RemoveUserAppDialog
                    title={t("@Remove application@")} meta={data}
                    showModal={showRemoveApp} closeModal={() => setShowRemoveApp(false)}/>
            }
            {
                showBetaDialog &&
                <BetaProgramDialog showModal={showBetaDialog} closeModal={()=>setShowBetaDialog(false)} join={!data.join_beta_program} app_id={data.app_id}/>
            }
        </>
    );
}

export default ApplicationRecord;